import { CALL_API } from 'redux-api-middleware'
import { get, post, put, destroy } from 'utils/network'

export const searchStudent = (studentID) => {
  const request = get('/students/search', { q: studentID, by: 'id' })
  request.types = ['NOOP', 'NOOP', 'NOOP']
  return { [CALL_API]: request }
}

export const loadUnpaidBilling = (studentID) => {
  const request = get(`/billings/${studentID}/unpaid`)
  request.types = ['_REQ', '_SUCC', 'NOTIF_FAIL']
  return { [CALL_API]: request }
}

export const saveNotePayment = (payload) => {
  let request = null
  if (payload.get('id')) {
    request = put(`/bulkcollections/${payload.get('id')}/approve`, payload)
  } else {
    request = post('/bulkcollections', payload)
  }
  request.types = ['NOTE_REQ', 'NOTE_SAVE_SUCC', 'NOTIF_FAIL']
  return { [CALL_API]: request }
}

export const fetchNotePayment = (id) => (dispatch, getState) => {
  if (getState().notepayment.getIn(['item', 'id']) === id) {
    return Promise.resolve()
  }
  const request = get(`/bulkcollections/${id}`)
  request.types = ['NOTE_REQ', 'NOTE_GET_SUCC', 'NOTIF_FAIL']
  return dispatch({ [CALL_API]: request })
}

export const searchNotePayment = (input) => {
  const query = {
    q: input,
    by: 'payee',
  }

  const s = input.split(':')
  if (s.length > 1) {
    query.q = s[1]
    query.by = s[0].toLowerCase()
  }

  const request = get('/bulkcollections/search', query)
  request.types = ['NOTE_Q_REQ', 'NOTE_Q_SUCC', 'NOTIF_FAIL']
  return { [CALL_API]: request }
}

export const rejectNotePayment = (id) => {
  const request = destroy(`/bulkcollections/${id}/reject`)
  request.types = ['NOTE_REQ', 'NOTE_DEL_SUCC', 'NOTIF_FAIL']
  return { [CALL_API]: request }
}



// WEBPACK FOOTER //
// ./src/containers/NotePayments/actions.js